interface Window { setCallback(callback: any): void; removeCallback(): void; }
interface Window { callback: any; }
interface Window { entryPoint: (authParams: any) => void }
declare var window: Window;

/**
 *
 */
export const setCallback = window.setCallback = (callback: any) => {
  window.callback = callback
}

export const removeCallback = window.removeCallback = () => {
  window.callback = null
}

/**
 * ブラウザから認証情報を渡してページをロードする関数
 */
window.entryPoint = (authParams: any) => {
  if (window.callback != null) {
    window.callback(authParams)
  }
}

